module.exports = __webpack_public_path__ + "static/media/mobile-step4-ar.png.524fd1ae.png";